import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Wishlist/WishlistSidebar/WishlistSidebar.container"
    ).then((module) => ({
        default: module.WishlistSidebarContainer
    }))
);
